import { render } from "./selectLanguage.vue?vue&type=template&id=1c9c32b6&scoped=true"
import script from "./selectLanguage.vue?vue&type=script&lang=js"
export * from "./selectLanguage.vue?vue&type=script&lang=js"

import "./selectLanguage.vue?vue&type=style&index=0&id=1c9c32b6&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9c32b6"]])

export default __exports__